var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 49,
  viewBox: "0 0 48 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_997_27703",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 48,
  height: 49
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24.5,
  r: 24,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_997_27703)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 24.5,
  r: 24,
  fill: "#8AD1EF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.2549 8.5C20.4571 8.5 16.5537 12.4033 16.5537 17.2012C16.5537 21.999 20.4571 25.9023 25.2549 25.9023C30.0527 25.9023 33.9561 21.999 33.9561 17.2012C33.9561 12.4033 30.0527 8.5 25.2549 8.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.0808 31.5868C33.6986 29.168 30.5406 27.8359 27.1885 27.8359H23.3213C19.9692 27.8359 16.8111 29.168 14.4289 31.5868C12.0584 33.9937 10.7529 37.1709 10.7529 40.5332C10.7529 41.0671 11.1858 41.5 11.7197 41.5C11.7197 41.5 17.2529 45.5 25.2549 45.5C32.2529 45.5 38.79 41.5 38.79 41.5C39.324 41.5 39.7568 41.0671 39.7568 40.5332C39.7568 37.1709 38.4513 33.9937 36.0808 31.5868Z",
  fill: "white"
}))));
export default SvgIconAvatar;